import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=230c12da&scoped=true&"
import script from "./imprint.vue?vue&type=script&lang=js&"
export * from "./imprint.vue?vue&type=script&lang=js&"
import style0 from "./imprint.vue?vue&type=style&index=0&id=230c12da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c12da",
  null
  
)

export default component.exports